
import Vue from "vue";

export default Vue.extend({
  name: "component-general-header",
  props: {
    title: { type: String, required: true },
  },
  methods: {
    closeBtnClicked() {
      this.$emit("close-btn-clicked");
    },
  },
});
